import { FC, forwardRef, PropsWithChildren } from 'react';
import {
  FormControl,
  FormLabel,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  InputProps,
} from '@chakra-ui/react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { BiCalendar } from 'react-icons/bi';

// styles
import 'react-datepicker/dist/react-datepicker.css';
import './date-picker.css';

type RefType = HTMLInputElement;
type InputWithLabelType = PropsWithChildren<InputProps & { label: string }>;

export const InputWithLabel = forwardRef<RefType, InputWithLabelType>(
  ({ label, ...inputProps }, ref) => {
    return (
      <InputGroup>
        <InputLeftAddon>
          <Icon as={BiCalendar} mr={2} />
          <FormLabel m={0}>{label}</FormLabel>
        </InputLeftAddon>
        <Input {...inputProps} ref={ref} />
      </InputGroup>
    );
  }
);

/**
 * react-datepicker does not use `DD` and `YYYY`
 * https://github.com/Hacker0x01/react-datepicker/issues/638#issuecomment-475643734
 * it uses unicode tokens under the hood
 * https://github.com/date-fns/date-fns/blob/main/docs/unicodeTokens.md
 */
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'; // example: 2023-01-28

type DatePickerProps = Omit<ReactDatePickerProps, 'dateFormat'> & {
  dateFormat?: string;
};

export const DatePicker: FC<DatePickerProps> = ({
  dateFormat = DEFAULT_DATE_FORMAT,
  placeholderText = DEFAULT_DATE_FORMAT.toUpperCase(),
  ...rest
}) => {
  return (
    <FormControl>
      {/* @ts-expect-error - ReactDatePicker type compatibility issue with React 17 */}
      <ReactDatePicker
        dateFormat={dateFormat}
        isClearable
        placeholderText={placeholderText}
        todayButton="Today"
        {...rest}
      />
    </FormControl>
  );
};
